// src/pages/Tools.js
import React from "react";
import { useNavigate } from "react-router-dom";
// Styles are imported globally via styles/index.css

function Tools() {
  const navigate = useNavigate();

  const modules = [
    {
      id: "mystery_client",
      title: "MysteryClient Upload Management",
      icon: require("../../Assets/mysteryclient.png"),
      path: "/versions",
    },
    {
      id: "sim_fix",
      title: "SimFix Management",
      icon: require("../../Assets/betwin.png"),
      path: "/admin/upload_simFix",
    },
  ];

  const handleModuleClick = (path) => {
    navigate(path);
  };

  return (
    <div className="home-container">
      {/* sfondo */}
      <div className="background-elements">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
        <div className="circle circle-3"></div>
      </div>

      <div className="content-wrapper">
        <header className="header-section">
          <h1 className="main-title">Tools Management</h1>
          <p className="subtitle">
            Seleziona un modulo per gestire i tuoi strumenti
          </p>
        </header>

        <div className="modules-grid">
          {modules.map((module) => (
            <div
              key={module.id}
              className={`module-card ${module.id.replace("_", "-")}`}
              onClick={() => handleModuleClick(module.path)}
            >
              <div className="module-icon">
                <img src={module.icon} alt={module.title} />
              </div>
              <h3 className="module-title">{module.title}</h3>
              <p className="module-description">{module.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Tools;
